import './App.css';
import { lazy, Suspense } from 'react';
import Main from './Components/Main/Main';
import DonateForm from './Components/Donations/DonationPage';
import About from './Components/About/About';
import GettingStarted from './Components/GettingStarted/GettingStarted';
import PublicOffer from './Components/PublicOffer/PublicOffer';
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy';
import Terms from './Components/Terms/Terms';
import ServerRules from './Components/ServerRules/ServerRules';
import PaymentResult from './Components/PaymentResult/PaymentResult';
import Contacts from './Components/Contacts/Contacts';
import { Routes, Route, Outlet } from 'react-router-dom';

import BodyBackgroundSync from './Components/Layouts/BodyBackgroundSync';
import MainLayout from './Components/Layouts/MainLayout';
import AdminLayout from './Components/Layouts/AdminLayout';
import WikiPage from './Components/Wiki/WikiPage';
import QuestCatalog from './Components/Wiki/QuestCatalog';
import WikiAdminLogin from './Components/WikiAdmin/WikiAdminLogin';
import ProtectedWikiRoute from './Components/WikiAdmin/ProtectedWikiRoute';
import WikiAdminPanel from './Components/WikiAdmin/WikiAdminPanel';
import WikiDashboard from './Components/WikiAdmin/WikiDashboard';
import WikiPagesManager from './Components/WikiAdmin/WikiPagesManager';
import WikiCategoriesManager from './Components/WikiAdmin/WikiCategoriesManager';
import WikiHistory from './Components/WikiAdmin/WikiHistory';
import WikiAdminAnalytics from './Components/WikiAdmin/WikiAdminAnalytics';
import WikiAdminGuide from './Components/WikiAdmin/WikiAdminGuide';
import WikiMapEditor from './Components/WikiAdmin/WikiMapEditor';
import WikiTournamentsManager from './Components/WikiAdmin/WikiTournamentsManager';
import WikiTournamentEditor from './Components/WikiAdmin/WikiTournamentEditor';
import WikiUsersManager from './Components/WikiAdmin/WikiUsersManager';
import TournamentsListPage from './Components/Tournaments/TournamentsListPage';
import TournamentPage from './Components/Tournaments/TournamentPage';
import RatingPage from './Components/Rating/RatingPage';
import ProfilePage from './Components/Community/AccountPage';
import MapPage from './Components/Map/MapPage';
import NotFound from './Components/NotFound/NotFound';

const Gallery = lazy(() => import('./Components/Community/Gallery'));
const PublicPlayer = lazy(() => import('./Components/Community/PublicPlayer'));
const GalleryModeration = lazy(() => import('./Components/Community/GalleryModeration'));
const communityPage = Component => <Suspense fallback={<p role="status">Загрузка…</p>}><Component /></Suspense>;

function App() {
  return (
    <>
      <BodyBackgroundSync />
      <Routes>
      {/* Админка: явный path /wiki/admin, свой layout с тёмным фоном */}
      <Route path="/wiki/admin" element={<AdminLayout />}>
        <Route path="login" element={<WikiAdminLogin />} />
        <Route element={<ProtectedWikiRoute><WikiAdminPanel /></ProtectedWikiRoute>}>
          <Route index element={<WikiDashboard />} />
          <Route path="pages" element={<WikiPagesManager />} />
          <Route path="categories" element={<WikiCategoriesManager />} />
          <Route path="history" element={<WikiHistory />} />
          <Route path="analytics" element={<WikiAdminAnalytics />} />
          <Route path="guide" element={<WikiAdminGuide />} />
          <Route path="map" element={<WikiMapEditor />} />
          <Route path="tournaments" element={<WikiTournamentsManager />} />
          <Route path="tournaments/:id" element={<WikiTournamentEditor />} />
          <Route path="users" element={<WikiUsersManager />} />
          <Route path="gallery" element={communityPage(GalleryModeration)} />
        </Route>
      </Route>

      {/* Основной сайт: layout с фоном-картинкой (все остальные пути). Дочерние пути — только относительные (parent path="*"). */}
      <Route path="*" element={<MainLayout />}>
        <Route index element={<Main />} />
        <Route path="donate" element={<DonateForm />} />
        <Route path="about" element={<About />} />
        <Route path="getting-started" element={<GettingStarted />} />
        <Route path="public-offer" element={<PublicOffer />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="server-rules" element={<ServerRules />} />
        <Route path="payment-success" element={<PaymentResult />} />
        <Route path="payment-failed" element={<PaymentResult />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="wiki" element={<Outlet />}>
          <Route path="quests/:questId?" element={<QuestCatalog />} />
          <Route path=":slug?" element={<WikiPage />} />
        </Route>
        <Route path="map" element={<MapPage />} />
        <Route path="rating" element={<RatingPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="players/:username" element={communityPage(PublicPlayer)} />
        <Route path="gallery" element={communityPage(Gallery)} />
        <Route path="tournaments" element={<TournamentsListPage />} />
        <Route path="tournaments/:id" element={<TournamentPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;
